import {
  GetInvoiceHistoryParam,
  GetInvoiceHistoryResponse,
} from '../../types/plansales/invoice/invoiceHistory';
import { AxiosResponse } from 'axios';
import api from 'api/coreApi';
import { convertObjectToArrayQuery } from '../../modules/utils/queryString';
import { GetInvoiceDetailResponse } from 'types/plansales/invoice/invoiceDetail';
/**
 * invoice history GET API
 * TODO: ted 께 swagger url 받기
 * @param pageNumber
 * @param startDate
 * @param endDate
 * @param planType
 * @param paymentMethod
 * @param paymentStatus
 * @param keyword
 * @param pageSize
 */
export const fetchInvoices = async ({
  pageNo = 1,
  startDate,
  endDate,
  planType = {},
  paymentMethod = {},
  paymentStatus = {},
  keyword = '',
  pageSize = 50,
}: GetInvoiceHistoryParam): Promise<AxiosResponse<GetInvoiceHistoryResponse>> => {
  const planTypeQuery = convertObjectToArrayQuery(planType, 'planTypes');
  const paymentMethodQuery = convertObjectToArrayQuery(paymentMethod, 'paymentMethods');
  const payStatusQuery = convertObjectToArrayQuery(paymentStatus, 'paymentStatus');

  return await api.get(
    `/closet/invoice?${planTypeQuery}&${paymentMethodQuery}&${payStatusQuery}&dateRange.startDate=${startDate}&dateRange.endDate=${endDate}&PageNo=${pageNo}&PageSize=${pageSize}&keyword=${keyword}`,
  );
};

/**
 * invoice item detail GET API
 * @param invoiceId
 */
export const fetchInvoiceDetail = ({
  invoiceId,
}: {
  invoiceId: string;
}): Promise<GetInvoiceDetailResponse | null> => {
  return api.get(`/closet/invoice/detail?invoiceId=${invoiceId}`).then(res => res.data);
};

export const retryPaymentByInvoice = async ({
  invoiceId,
  comment,
}: {
  invoiceId: string;
  comment: string;
}): Promise<void> => {
  return await api.post(`/closet/invoice/retry?invoiceId=${invoiceId}`, { Comment: comment });
};
